
/* SkyParam
 * Skyに渡すパラメータ.
 */
import {SkyShader} from "../../../digifie/utils";
import {AmbientLight, Sun} from "./View3dLight";
import * as THREE from "three";
import {Scene} from "./View3dScene";

export class SkyParam {
    public turbidity: number = 1;
    public rayleigh: number = 0.78;
    public mieCoefficient: number = 0.02;
    public mieDirectionalG: number = 0.9;
    public luminance: number = 1;
    public inclination: number = 0.8;
    public azimuth: number = 0.8;
    public sunDiskIntensity: number = 1.0;
    public ambient: number = 0.2;
    public distantLight: number = 1.0;
    public distance: number = 400.0;
    public dlpo_x: number = -0.3;
    public dlpo_y: number = 1.0;
    public dlpo_z: number = 0.6;
}

/* Sky
 * Skyレンダラ.
 */
export class Sky {
    _instance: SkyShader;
    public get me(): SkyShader { return this._instance; }
    public set me(i: SkyShader) { this._instance = i; }

    private _param: SkyParam;
    private _sun: Sun;
    private _ambient: AmbientLight;
    public get sun(): Sun { return this._sun; }
    public get ambient(): AmbientLight { return this._ambient; }
    protected setSunPosition(pos: THREE.Vector3) {
        if (this._sun != undefined) this._sun.position.copy(pos);
    }

    constructor() {
        this._param = new SkyParam;

        this.createSun();
        this.createAmbient();
        this.createSky();
    }
    public get position(): THREE.Vector3 { return this._sun.position; }
    public set position(pos: THREE.Vector3) { this._sun.position.set(pos.x, pos.y, pos.z); }
    public get param(): SkyParam { return this._param; }
    public set param(prm: SkyParam) {
        this._param = prm;
        this.me.uniforms.turbidity.value = prm.turbidity;
        this.me.uniforms.rayleigh.value = prm.rayleigh;
        this.me.uniforms.luminance.value = prm.luminance;
        this.me.uniforms.mieCoefficient.value = prm.mieCoefficient;
        this.me.uniforms.mieDirectionalG.value = prm.mieDirectionalG;
        this.me.uniforms.sunDiskIntensity.value = prm.sunDiskIntensity;

        const theta = Math.PI * (prm.inclination - 0.5);
        const phi = 2 * Math.PI * (prm.azimuth - 0.5);
        let position = new THREE.Vector3(
            prm.distance * Math.cos(phi),
            prm.distance * Math.sin(phi) * Math.sin(theta),
            prm.distance * Math.sin(phi) * Math.cos(theta));

        position.normalize();
        this.me.uniforms.sunPosition.value.x = position.x;
        this.me.uniforms.sunPosition.value.y = position.y;
        this.me.uniforms.sunPosition.value.z = position.z;
        this.setSunPosition(position);
    }

    protected createSun() {
        this._sun = new Sun(0xffffff, 0);
        // this._sun = new Sun(0xffffff, 0.65);
    }
    protected createAmbient() {
        this._ambient = new AmbientLight(0xffffff * 0.2);
    }
    protected createSky() {
        this.me = new SkyShader;
        this.me.mesh.name = "空";
        this.param = this._param;
    }
    public showHide(value: boolean) {
        this.me.mesh.visible = value ? true : false;
    }

    public apply(scene: Scene) {
        if (this.me != undefined) scene.me.add(this.me.mesh);
        if (this._sun != undefined) {
            scene.me.add(this._sun.me);
        }
        if (this._ambient != undefined) scene.me.add(this._ambient.me);
    }

    public reset(scene: Scene) {
        if (this.me != undefined) scene.me.remove(this._ambient.me);
        if (this._sun != undefined) scene.me.remove(this.me.mesh);
        if (this._ambient != undefined) scene.me.remove(this._sun.me);

        this.me = undefined;
        if (this._sun != undefined) {
            this._sun.reset();
            this._sun = undefined;
        }
        if (this._ambient != undefined) {
            this._ambient.reset();
            this._ambient = undefined;
        }
    }
}
